<template>
  <v-dialog
    width="600px"
    persistent
    :value="showDialog"
  >
    <v-card>
      <v-card-title class="text-h5">
        {{ $t('dss.multipleMedicationClasses.title', {catalog: 'app_dashboard'}) }}
      </v-card-title>
      <v-card-text>
        {{ $t('dss.multipleMedicationClasses.warning', {catalog: 'app_dashboard', params: { 'medicationClasses': duplicatedClasses} }) }}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="grey darken-1"
          text
          @click="$emit('close')"
        >
          {{ $t('Cancel') }}
        </v-btn>
        <v-btn
          color="green darken-1"
          text
          @click="$emit('handleSubmit')"
        >
          {{ $t('Submit') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/**
 * Component DuplicatedClassPopup.vue
 *
 * @module DuplicatedClassPopup
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [4.10] app/src/APP_DASHBOARD/templates/components/Parts/DSS/DuplicatedClassPopup.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "DuplicatedClassPopup",
  props: {
    duplicatedClasses: {
      type: String,
      default: () => ''
    },
    value: {
      type: Boolean
    }
  },
  data() {
    return {}
  },
  computed: {
    showDialog() {
      return this.value;
    },
  }
}
</script>